export var SUBMISSION_REPOSITORY = 'SUBMISSION_REPOSITORY';